import React, { useCallback, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import AccountDetailsCard from "./components/account-details-card/account-details-card";
import BasePageLayout from "../../components/layouts/base-page-layout/base-page-layout";
import EditorPageLayout from "../../components/layouts/editor-page/editor-page-layout";
import useValidationGroup from "../../hooks/validation-group/validation-group-hook";
import { ConfirmModal } from "../../components/modal/components/confirm-modal/confirm-modal";
import useNavigationBlocker from "../../hooks/navigation-blocker-hook";
import currentAccountStore from "./stores/current-account-store";
import dashboardTranslationsStore from "../../dashboard-translation/stores/dashboard-translations-store";

const ProfilePage: React.FC = observer(() => {
    const vGroup = useValidationGroup();
    const store = currentAccountStore.account;
    useEffect(() => {
        currentAccountStore.load();
    }, []);

    const [isShowUnsaved, setIsShowUnsaved] = useState(false);
    const hasChanges = (): boolean => {
        return store?.hasChanges() || false;
    }

    const saveChanges = async () => {
        await store?.saveProfile();
        unblockNavigation();
    }

    const discardChanges = () => {
        store?.discardChanges();
    }

    const { retryNavigation, unblockNavigation } = useNavigationBlocker(
        () => hasChanges(),
        useCallback(() => setIsShowUnsaved(true), [setIsShowUnsaved])
    );

    return (
        <BasePageLayout title={'Profile'}>
            <EditorPageLayout
                toolbar={{
                    hasLocalesSelector: false,
                    saveButton: {
                        hasChanges: hasChanges(),
                        onClick: () => saveChanges(),
                        disabled: !vGroup.isValid() || !hasChanges(),
                    },
                    isLoading: store?.isSaving() || currentAccountStore?.isLoading || dashboardTranslationsStore.isLoading
                }}>
                <AccountDetailsCard
                    account={store}
                    validationGroup={vGroup}
                    resetPasswordEnabled
                />
                {isShowUnsaved &&
                    <ConfirmModal
                        cancelButton={{
                            title: 'Cancel',
                            onClick: () => setIsShowUnsaved(false)
                        }}
                        okButton={{
                            title: 'Discard',
                            onClick: () => {
                                discardChanges();
                                setIsShowUnsaved(false);
                                retryNavigation();
                            }
                        }}
                    />
                }
            </EditorPageLayout>
        </BasePageLayout>
    );
});

export default ProfilePage;
